import React from "react";

//interfaces
import { IDirectionalToggle } from "../../../../interfaces/toggles/IToggle";

//hooks
import UseDirectionalToggle from "./DirectionalToggle.hooks";


const DirectionalToggle = ({direction, sortAscending, sortDescending, text, defaultSort, onRemoveDefaultSort, ascendingLabel, descendingLabel}: IDirectionalToggle) => {
    const { 
        getAriaLabel, 
        handleClick, 
        getToggleIcon 
    } = UseDirectionalToggle({direction, sortAscending, sortDescending, text, defaultSort, onRemoveDefaultSort, ascendingLabel, descendingLabel});

    return (
        <button 
            className="toggle-caret" 
            aria-label={getAriaLabel()} 
            onClick={handleClick} 
        >
            {text && <span>{text}</span>}
            
            {getToggleIcon()}
        </button>
    );
};

export default DirectionalToggle;